import defaultClient from '@src/api/clients/default';

// ─── Hub endpoints ──────────────────────────────────────────────────

export function fetchMappings(params = {}) {
  const query = new URLSearchParams(params).toString();
  return defaultClient.request({
    url: `dashboard/data-integrations/mappings/?${query}`,
    method: 'GET',
  });
}

export function fetchMetadata() {
  return defaultClient.request({
    url: 'dashboard/data-integrations/metadata/',
    method: 'GET',
  });
}

export function autoMatchColumns(payload) {
  // payload can be { headers: [...] } or FormData with a file
  if (payload instanceof FormData) {
    return defaultClient.request({
      url: 'dashboard/data-integrations/auto-match/',
      method: 'POST',
      payload,
      multipart: true,
    });
  }
  return defaultClient.request({
    url: 'dashboard/data-integrations/auto-match/',
    method: 'POST',
    payload,
  });
}

export function previewCsv(formData) {
  return defaultClient.request({
    url: 'dashboard/data-integrations/preview/',
    method: 'POST',
    payload: formData,
    multipart: true,
  });
}

export function testApiConnection(payload) {
  return defaultClient.request({
    url: 'dashboard/data-integrations/test-api/',
    method: 'POST',
    payload,
  });
}

export function testSftpConnection(payload) {
  return defaultClient.request({
    url: 'dashboard/data-integrations/test-sftp/',
    method: 'POST',
    payload,
  });
}

export function processManualUpload(formData) {
  return defaultClient.request({
    url: 'dashboard/data-integrations/process-upload/',
    method: 'POST',
    payload: formData,
    multipart: true,
  });
}

export function fetchImportHistory(params = {}) {
  const query = new URLSearchParams(params).toString();
  return defaultClient.request({
    url: `dashboard/data-integrations/import-history/?${query}`,
    method: 'GET',
  });
}

export function fetchIntegrationHealth(params = {}) {
  const query = new URLSearchParams(params).toString();
  return defaultClient.request({
    url: `dashboard/data-integrations/health/?${query}`,
    method: 'GET',
  });
}

// ─── Per-type CRUD ──────────────────────────────────────────────────

const MAPPING_ENDPOINTS = {
  email: 'dashboard/client-email-mappings',
  sftp: 'dashboard/client-sftp-mappings',
  api: 'dashboard/client-api-mappings',
  google_sheet: 'dashboard/client-google-sheet-mappings',
  manual: 'dashboard/client-manual-upload-mappings',
};

export function createMapping(type, payload) {
  const base = MAPPING_ENDPOINTS[type];
  return defaultClient.request({ url: `${base}/`, method: 'POST', payload });
}

export function updateMapping(type, id, payload) {
  const base = MAPPING_ENDPOINTS[type];
  return defaultClient.request({ url: `${base}/${id}/`, method: 'PATCH', payload });
}

export function deleteMapping(type, id) {
  const base = MAPPING_ENDPOINTS[type];
  return defaultClient.request({ url: `${base}/${id}/`, method: 'DELETE' });
}

export function fetchMapping(type, id) {
  const base = MAPPING_ENDPOINTS[type];
  return defaultClient.request({ url: `${base}/${id}/`, method: 'GET' });
}
